/**
 * Calculates the median of an array of numbers.
 * If array contains 0 elements then returns undefined.
 * If array contains an even number of elements, will return
 * the average of the two middle numbers.
 *
 * @param values - Array of numbers to find median in
 * @returns The median for the given set of numbers
 */
export function median(values: number[]): number | undefined {
    const length = values.length;

    if (length === 0) {
        return undefined;
    }

    const sortedValues = [...values].sort();

    const middleIndex = length / 2;
    let result;

    if (length % 2 === 0) {
        const left = sortedValues[Math.floor(middleIndex)];
        const right = sortedValues[Math.ceil(middleIndex)];
        result = (left + right) / 2;
    } else {
        result = sortedValues[Math.floor(middleIndex)];
    }

    return result;
}
